import {loadFeatureFlags as loadDashboardFeatureFlags} from '@telstra-connect/dashboard/feature-flags/load-flags'
import {loadFeatureFlags as loadServicePerformanceFeatureFlags} from '@telstra-connect/service-performance/feature-flags'
import global from '@applications'

export const setFeatureFlags = () => {
  const getFlagsConfigFromState = () => global.applications
  loadDashboardFeatureFlags(getFlagsConfigFromState)
  loadServicePerformanceFeatureFlags(getFlagsConfigFromState)
}
